export default __webpack_public_path__ + "static/media/employee.94a11ea2.svg";